import React from "react";
import { connect } from "react-redux";
import { WeeklyOffJsonNew } from "../../DynamicFormsJson/MastersJSON/WeeklyOffNew";
import { getAllWeeklyOffUserWise } from "../../Slice/weeklyOff.slice";
import DynamicMainScreen from "../../components/dynamicscreens/DynamicMainScreen";
import { noInternetMsg, serverMsg } from "../../config/messageconstant";
import { WeeklyOffUserWiseColumns } from "../../tableColumns/table-columns";
import { showLoador, showNotification } from "../Landing/Landing.slice";

class WeeklyOffTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      adminFlag: false,
    };
  }
  async componentDidMount() {
    const { getAllWeeklyOffUserWise, showLoador, showNotification } =
      this.props;

    if (navigator.onLine) {
      showLoador({ loador: true });
      getAllWeeklyOffUserWise().then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
      this.getData();
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  getData = async () => {
    const { getAllWeeklyOffUserWise, showLoador, showNotification } =
      this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      await getAllWeeklyOffUserWise({}).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  render() {
    const { weeklyOffList } = this.props;
    const { dynamicMasterData, adminFlag } = this.state;

    return (
      <>
        <DynamicMainScreen
          showViewButtonInTable={true}
          showDeleteIcon={true}
          dynamicMasterData={dynamicMasterData}
          searchList={WeeklyOffJsonNew.searchList}
          getTableData={this.getData}
          formPathView={WeeklyOffJsonNew.formPathView}
          formPath={WeeklyOffJsonNew.formPath}
          screenTitle={WeeklyOffJsonNew.screenTitle}
          fieldMeta={WeeklyOffJsonNew.fieldMeta}
          showPdfDownload={false}
          showExcelDownload={false}
          isActiveURL={WeeklyOffJsonNew.isActiveURL}
          showAddButton={WeeklyOffJsonNew.showAddButton}
          tableColumnsToFilter={WeeklyOffJsonNew.tableColumnsToFilter}
          tableColumns={WeeklyOffUserWiseColumns}
          tableData={weeklyOffList?.weeklyOff}
          apiBaseURL={WeeklyOffJsonNew.apiBaseURL}
          callApi={false}
          getTableDataById={true}
          showPegination={false}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  weeklyOffList: state.weeklyOff,
});
const mapDispatchToProps = {
  showLoador,
  showNotification,
  getAllWeeklyOffUserWise,
};
export default connect(mapStateToProps, mapDispatchToProps)(WeeklyOffTable);
